import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, withRouter } from 'react-router-dom'

import HeaderBar from './header-bar';
import LandingPage from './landing-page';
import Dashboard from './dashboard';
import RegistrationPage from './registration-page';
import ViewText from './view-text'
import SubmitText from './submit-text'
import EditText from './edit-text'
import ViewEdit from './view-edit'
import ViewUser from './view-user'
import ExplorePage from './explore-page'
import { refreshAuthToken } from '../actions/auth'
import { FileNotFound } from './file-not-found'

export class App extends React.Component {
    componentDidMount() {
        if (this.props.hasAuthToken) {
            this.props.dispatch(refreshAuthToken())
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loggedIn && !this.props.loggedIn) {
            this.startPeriodicRefresh()
        } else if (!nextProps.loggedIn && this.props.loggedIn) {
            this.stopPeriodicRefresh()
        }
    }

    componentWillUnmount() {
        this.stopPeriodicRefresh()
    }

    startPeriodicRefresh() {
        this.refreshInterval = setInterval(
            () => this.props.dispatch(refreshAuthToken()), 
            60 * 60 * 1000
        )
    }

    stopPeriodicRefresh() {
        if (!this.refreshInterval) {
            return
        }

        clearInterval(this.refreshInterval)
    }

    render() {
        return (
            <BrowserRouter>
                <div className="app">
                    <HeaderBar />
                    <Route exact path="/" component={LandingPage} />
                    <Route exact path="/dashboard" component={Dashboard} />
                    <Route exact path="/register" component={RegistrationPage} />
                    <Route exact path="/submit" component={SubmitText} />
                    <Route exact path="/text/:title" component={ViewText} />
                    <Route exact path="/edit/:title" component={EditText} />
                    <Route exact path="/edited/:title" component={ViewEdit} /> 
                    <Route exact path="/user/:userId" component={ViewUser} />
                    <Route exact path='/404/not-found' component={FileNotFound} />
                    <Route exact path='/explore' component={ExplorePage} />
                </div>
            </BrowserRouter>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.auth.currentUser,
    hasAuthToken: state.auth.authToken !== null,
    loggedIn: state.auth.currentUser !== null
})

export default withRouter(connect(mapStateToProps)(App))



// WEBPACK FOOTER //
// ./src/components/app.js